export type CreateUserProfileMutationResult = {
    data: {
        createUserProfile: {
            userId: string;
            email: string;
        } | null;
    };
};

export const createUserProfileMutation = `
  mutation CreateUserProfile($firstName: String!, $lastName: String!, $phoneNumber: String!, $email: String!, $password: String!) {
    createUserProfile(firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, email: $email, password: $password) {
      userId
      email
    }
  }
`;


export type SignupResult = {
    success: boolean;
    reason?: 'email-exists' | 'signup-failed';
};